import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import imgNotFound from "../assets/images/not-found.png";
import "./SiteRemoved.scss";

export default (props) =>
  <div className="removed-site">
    <img src={imgNotFound} alt="not found" />
    <div className="notification">This site has been removed</div>
    <Button variant="danger" size="sm"><Link to={props.isAuthenticated ? '/dashboard' : '/login'}>GO BACK TO THE APP</Link></Button>
  </div>;
